import React from "react";

/**
 * Shown when a fee proof has no image (e.g. admin-recorded payment without upload).
 * This is a valid state, not an error.
 */
export default function FeeImagePlaceholder({
  height = "100%",
  minHeight = 220,
  title = "No image attached",
  description = "This proof was recorded without an uploaded receipt image (manual entry).",
}) {
  return (
    <div
      style={{
        width: "100%",
        height,
        minHeight,
        borderRadius: "12px",
        border: "1px dashed #cfc9e0",
        background:
          "linear-gradient(160deg, #f7f5fc 0%, #efeaf8 55%, #f4f1ea 100%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        padding: "24px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          width: "54px",
          height: "54px",
          borderRadius: "14px",
          backgroundColor: "#e5dff7",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <i
          className="fa-regular fa-image"
          style={{ fontSize: "22px", color: "#6d6688" }}
        />
      </div>
      <div
        style={{
          fontSize: "14px",
          fontWeight: "700",
          color: "#403b55",
          letterSpacing: "0.2px",
        }}
      >
        {title}
      </div>
      <div style={{ fontSize: "12px", color: "#77718b", maxWidth: "260px" }}>
        {description}
      </div>
    </div>
  );
}
